import { createCustomEnum } from "./customEnum";

const GiactVerificationResponse = createCustomEnum({
	error: {
		name: "error",
		value: 0,
		displayName: "Error",
	},
	private_bad_checks_list: {
		name: "private_bad_checks_list",
		value: 1,
		displayName: "Private Bad Checks List",
	},
	declined: {
		name: "declined",
		value: 2,
		displayName: "Declined",
	},
	reject_item: {
		name: "reject_item",
		value: 3,
		displayName: "Reject Item",
	},
	accept_with_risk: {
		name: "accept_with_risk",
		value: 4,
		displayName: "Accept With Risk",
	},
	risk_alert: {
		name: "risk_alert",
		value: 5,
		displayName: "Risk Alert",
	},
	pass: {
		name: "pass",
		value: 6,
		displayName: "Pass",
	},
	pass_ndd: {
		name: "pass_ndd",
		value: 7,
		displayName: "Pass Ndd",
	},
	negative_data: {
		name: "negative_data",
		value: 8,
		displayName: "Negative Data",
	},
	no_data: {
		name: "no_data",
		value: 9,
		displayName: "No Data",
	},
});

export default GiactVerificationResponse;
